export const EmployeePickList = ({ shown, selected, toggle, allShownSelected, toggleAll }) => (
  <div className="border border-stone-200 rounded-lg max-h-56 overflow-y-auto divide-y divide-stone-100" data-testid="mark-attendance-employee-list">
    <label className="flex items-center gap-3 px-4 py-2.5 bg-stone-50 cursor-pointer text-sm font-bold sticky top-0">
      <input type="checkbox" checked={allShownSelected} onChange={toggleAll} data-testid="mark-attendance-select-all" className="w-4 h-4 accent-[#C84C08]" />
      Select all shown ({shown.length})
    </label>
    {shown.length === 0 && <p className="px-4 py-6 text-center text-sm text-stone-400">No matching employees.</p>}
    {shown.map((e) => (
      <label key={e.id} className="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-stone-50 text-sm">
        <input type="checkbox" checked={selected.includes(e.id)} onChange={() => toggle(e.id)}
          data-testid={`mark-attendance-check-${e.id}`} className="w-4 h-4 accent-[#C84C08]" />
        <span className="font-semibold">{e.name}</span>
        <span className="text-xs text-stone-500">{e.employee_code} · {e.department || "—"}</span>
      </label>
    ))}
  </div>
);
